import { BellRing } from 'lucide-react';
import { useEffect, useState } from 'react';

import { AlertDialog, AlertDialogAction, AlertDialogBody, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { useLocalStorage } from '@/hooks/local-storage';
import { useManageNotifications } from '@/hooks/notifications';

export default function NotificationPermissionAlert() {
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const { isDefault, enableNotifications, disableNotifications } = useManageNotifications();
  const [hasPrompted, setHasPrompted] = useLocalStorage<boolean>('notificationPrompted', false);

  const onAllow = () => {
    enableNotifications();
    setHasPrompted(true);
    setShowAlert(false);
  };
  const onDeny = () => {
    disableNotifications();
    setHasPrompted(true);
    setShowAlert(false);
  };

  useEffect(() => {
    if (isDefault && !hasPrompted) {
      setShowAlert(true);
    }
    setHasPrompted(true);
  }, [isDefault, hasPrompted]);

  return (
    <AlertDialog open={showAlert} onOpenChange={setShowAlert}>
      <AlertDialogContent className={'sm:max-w-110'}>
        <AlertDialogBody>
          <AlertDialogHeader>
            <FeaturedIcon>
              <BellRing />
            </FeaturedIcon>
            <div className={'flex min-w-0 grow flex-col gap-0.5'}>
              <AlertDialogTitle>Chcesz otrzymywać powiadomienia ?</AlertDialogTitle>
              <p className={'text-muted-foreground text-xs'}>
                Wyraź zgodę na powiadomienia, aby otrzymywać najnowsze informacje. Możesz w każdej chwili zmienić swoje preferencje w ustawieniach aplikacji.
              </p>
            </div>
          </AlertDialogHeader>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel variant={'tertiary'} onClick={onDeny}>
            Zamknij
          </AlertDialogCancel>
          <AlertDialogAction onClick={onAllow}>Potwierdź</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
